const baseURL = KE_GLOBAL_VARS['site_url'] + '/'

jQuery(document).ready(function ($) {
    /* Variables
    ---------------------------------------------------------------------------------------------------- */
    var mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
        ? true
        : false

    /* Menu
    ---------------------------------------------------------------------------------------------------- */
    var stickyOffset = $('.sticky').offset().top

    var menuPosition = function () {
        var sticky = $('.sticky')
        scroll = $(window).scrollTop()
        if (scroll > 129 && $(window).width() > 991) {
            $('body').addClass('sticky-fixed')
        } else {
            $('body').removeClass('sticky-fixed')
        }
    }

    $('#dropdownMenuButton').click(function () {
        $('.container-icon-language').removeClass('d-none')
        $('.container-icon-language').addClass('d-flex')
    })

    $('.close-choose-language').click(function () {
        $('.container-icon-language').addClass('d-none')
        $('.container-icon-language').removeClass('d-flex')
    })

    menuPosition()
    $(window).scroll(menuPosition)

    $('#btn-toogle-menu').click(function () {
        if ($('#menuPrincipal').hasClass('show')) {
            $('#header-menu-wrapper').css({
                opacity: 0,
                zIndex: 'initial',
            })
            $('body').css({
                overflow: 'visible',
            })
        } else {
            $('#header-menu-wrapper').css({
                opacity: 1,
                zIndex: '5',
            })
            $('body').css({
                overflow: 'hidden',
            })
        }
    })
})

/* Back to top
---------------------------------------------------------------------------------------------------- */
var scrollToTop = function () {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    })
}

// display search bar
const $containerSearch = document.querySelector('#header #header-search-wrapper')
const $containerIcons = document.querySelector('#header .container-icons')
const $iconSearch = document.querySelector('.container-icons .icon-search i')
const $navBar = document.querySelector('#main-menu')

if (window.innerWidth <= 992) {
    $navBar.appendChild($containerIcons)
    $navBar.appendChild($containerSearch)
}
window.addEventListener('resize', function () {
    if (window.innerWidth <= 992) {
        $navBar.appendChild($containerIcons)
        $navBar.appendChild($containerSearch)
    }
})

$iconSearch.addEventListener('click', () => {
    $containerSearch.classList.toggle('show')
})

// Moove search bar in nav for responsive

// Redirect front page
function link(pageId, className, url) {
    if (document.querySelector('body').classList[3] === pageId) {
        className.addEventListener('click', function () {
            window.location.href = url
        })

        className.addEventListener('mouseenter', function (e) {
            e.target.childNodes[1].classList.add('pulse')
        })
    }
}

// EN
link('page-id-17254', document.querySelector('.link-how-en'), baseURL + 'how-does-it-work/')
link('page-id-17254', document.querySelector('.link-history-en'), baseURL + 'arinc-818-history/')
link('page-id-17254', document.querySelector('.link-terms-en'), baseURL + 'arinc-818-terms/')
link('page-id-17254', document.querySelector('.link-market-en'), baseURL + 'market/')
link('page-id-17254', document.querySelector('.link-ressources-en'), baseURL + 'resources/')

//FR
link(
    'page-id-17280',
    document.querySelector('.link-how-fr'),
    baseURL + 'decouvrir-le-protocole-arinc-818/'
)
link('page-id-17280', document.querySelector('.link-history-fr'), baseURL + 'historique-arinc818/')
link('page-id-17280', document.querySelector('.link-terms-fr'), baseURL + 'glossaire/')
link('page-id-17280', document.querySelector('.link-market-fr'), baseURL + 'solutions/')
link('page-id-17280', document.querySelector('.link-ressources-fr'), baseURL + 'ressources/')

//DE
link('page-id-17302', document.querySelector('.link-how-de'), baseURL + 'entdecke-das-protokoll/')
link('page-id-17302', document.querySelector('.link-history-de'), baseURL + 'geschichte-arinc-818/')
link('page-id-17302', document.querySelector('.link-terms-de'), baseURL + 'glossar/')
link('page-id-17302', document.querySelector('.link-market-de'), baseURL + 'markt/')
link('page-id-17302', document.querySelector('.link-ressources-de'), baseURL + 'ressourcen/')

//Graph front-page
const $containerGraph = document.querySelector('.graph-canvas')
const $canvas = document.createElement('canvas')

$canvas.id = 'myChart'
$canvas.width = 328
$canvas.height = 328

const $body = document.querySelector('body')
const pageId = $body.classList[3]
if (pageId === 'page-id-17302' || pageId === 'page-id-17280' || pageId === 'page-id-17254') {
    $containerGraph.appendChild($canvas)
}

const ctx = $canvas.getContext('2d')

const ratio = 0.1

const options = {
    root: null,
    rootMargin: '0px',
    threshold: ratio,
}

const callback = (entries, observer) => {
    entries.forEach((entry, index) => {
        if (entry.intersectionRatio > ratio) {
            // After scroll > 1 observer is stopped
            observer.unobserve(entry.target)
            const myChart = new Chart(ctx, {
                type: 'horizontalBar',
                data: {
                    labels: [
                        '1.0625',
                        '2.125',
                        '3.1875',
                        '4.25',
                        '5.0',
                        '6.375',
                        '8.5',
                        '12.75',
                        '14.025',
                        '21.0375',
                        '28.05',
                    ],
                    datasets: [
                        {
                            label: 'ARINC 818 link speeds (Gb/s)',
                            data: [
                                1.0625,
                                2.125,
                                3.1875,
                                4.25,
                                5.0,
                                6.375,
                                8.5,
                                12.75,
                                14.025,
                                21.0375,
                                28.05,
                            ],
                            backgroundColor: [
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                                'rgb(181, 204, 58)',
                            ],
                        },
                    ],
                },
                options: {
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                },
                            },
                        ],
                    },
                },
            })
        }
    })
}

if (
    document.querySelector('body').classList[3] === 'page-id-17280' ||
    document.querySelector('body').classList[3] === 'page-id-17254' ||
    document.querySelector('body').classList[3] === 'page-id-17302'
) {
    const observer = new IntersectionObserver(callback, options)
    observer.observe(document.querySelector('.container-graph'))
}
